import { useMutation } from "react-query";

import type {
  BookingIntervalResponse,
  PostManagerBookingIntervalArgs,
} from "api/services/appointment/schemas/booking_interval";
import { useApiClient } from "api/useApiClient";

export const usePostManagerBookingInterval = () => {
  const client = useApiClient();

  return useMutation<BookingIntervalResponse, Error, PostManagerBookingIntervalArgs>({
    mutationFn: args => client.postManagerBookingInterval(args),
  });
};
